import React, { useEffect, useState } from 'react';
import { Box, Grid, Button, Container, Typography } from '@material-ui/core';
import i18n from 'i18n-js';
import Can from 'components/Can';
import Layout from 'components/Layout';
import Feature from 'components/Feature';
import Comments from 'components/Comments';
import useStyles from './UserDetails.styled';
import { usersActions } from 'state/modules/users';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter, useParams } from 'react-router-dom';
import { ChangeUserStatusModal } from 'components/Modals';
import { NFCDetailsWidget } from 'components/AccessDevice';
import { ReservationsWidget } from 'components/Reservations';
import { Details, UserLogs, VehicleGroups, UserGroups } from 'components/Users';

const UserDetails = ({ history }) => {
  const classes = useStyles();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { user } = useSelector((state) => state.users);
  const { userPrivileges } = useSelector((state) => state.users);

  useEffect(() => {
    dispatch(usersActions.fetchUserPrivileges(id));
  }, [id, dispatch]);

  const requiredVGWidget = userPrivileges?.vehicle_group
    ? userPrivileges?.vehicle_group.find((val) => val !== '*' && val !== 'access_all')
    : true;

  /**
   * Open change user status modal
   */
  const handleChangeUserStatus = () => {
    setOpen((prevState) => !prevState);
  };

  const Title = () => (
    <>
      {`${user?.first_name || ''} ${user?.last_name || ''}`} ID#{id}
    </>
  );

  return (
    <Layout title="User">
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container direction="row" justifyContent="space-between" spacing={2}>
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  <Box fontWeight="fontWeightBold" fontSize={24} mb={1}>
                    <Title />
                  </Box>
                </Typography>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleChangeUserStatus}
                  data-cy={'change-user-status-button'}
                  style={{ textTransform: 'inherit' }}
                >
                  {i18n.t('users.change_status')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Details id={id} />
                  </Grid>
                  <Feature name="reservation" is="enabled">
                    <Grid item xs={12}>
                      <ReservationsWidget
                        type="user"
                        history={history}
                        customParams={{ user_id: id }}
                      />
                    </Grid>
                  </Feature>
                  <Can I="read" on="user_group">
                    <Grid item xs={12}>
                      <UserGroups id={id} />
                    </Grid>
                  </Can>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Feature name="access_device" is="nfc_allowed">
                    <Grid item xs={12}>
                      <NFCDetailsWidget user={user} view="customer" />
                    </Grid>
                  </Feature>
                  {id && (
                    <Can I="read" on="event_log">
                      <Grid item xs={12}>
                        <UserLogs title={i18n.t('users.logs')} id={id} />
                      </Grid>
                    </Can>
                  )}
                  {requiredVGWidget && (
                    <Grid item xs={12}>
                      <VehicleGroups id={id} />
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Comments type="user" id={parseInt(id)} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {open && (
          <ChangeUserStatusModal
            id={id}
            open={open}
            status={user?.status}
            handleClick={handleChangeUserStatus}
            userType="EMPLOYEE"
          />
        )}
      </Container>
    </Layout>
  );
};

export default withRouter(UserDetails);
